export interface DownloadJobModel {
  jobId: string;
  status: DownloadJobStatus;
  progress: number;
  fileName?: string;
  downloadUrl?: string;
  errorMessage?: string;
  createdDate: Date;
  completedDate?: Date;
  expiresDate?: Date;
  projectId: number;
  postId: number;
  isDirectDownload: boolean;
}

export enum DownloadJobStatus {
  Queued = 'Queued',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface DownloadJobQueueResponse {
  jobId: string;
  message: string;
}

export interface DownloadJobNotification {
  jobId: string;
  status: string;
  progress: number;
  downloadUrl?: string;
  fileName?: string;
  expiresDate?: Date;
  errorMessage?: string;
}
